export default "__VITE_ASSET__4c30b9c0__"